<template>
    <v-layout justify-center>
        <v-responsive max-width="1280px" width="100%">
            <list-heading v-model="showsSearch" :title="`${title} 목록`" />
            <!-- <counsels-search v-model="filter" :type="type" :showsSearch="showsSearch" @search="(page = 1) && search()" /> -->
            <v-data-table :items="requests" :headers="headers" hide-default-footer disable-sort class="my-4 v-sheet--outlined">
                <template v-slot:[`item.area`]="{ item }"> {{ item.area.parent.name }} / {{ item.area.name }} </template>
                <template v-slot:[`item.createdAt`]="{ item }">
                    {{ item.createdAt.toDateTime() }}
                </template>
                <template v-slot:[`item._requestees.length`]="{ item }">
                    <counsels-requestees :value="item" @input="syncItem" />
                </template>
                <template v-slot:[`item.isDone`]="{ item }">
                    <counsels-toggle-isdone :value="item" @input="syncItem" />
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <counsels-report :request="item" />
                </template>
            </v-data-table>

            <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="my-4" @input="search()"></v-pagination>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import ListHeading from "@/components/console/dumb/list-heading.vue";
import CounselsReport from "@/components/console/counsels/counsels-report.vue";
import CounselsSearch from "@/components/console/counsels/counsels-search.vue";
import CounselsRequestees from "@/components/console/counsels/counsels-requestees.vue";
import CounselsToggleIsdone from "@/components/console/counsels/counsels-toggle-isdone.vue";

const TITLES = {
    short: "이음자문",
    long: "멘토링",
};

const headers = [
    { text: "분야", value: "area", align: "center" },
    { text: "기업명", value: "requester.companyName", align: "center" },
    { text: "담당자명", value: "requester.workerName", align: "center" },
    { text: "연락처", value: "requester.phone", align: "center" },
    { text: "배정자문인력", value: "_requestees.length", align: "center" },
    { text: "작성일", value: "createdAt", align: "center" },
    { text: "종료", value: "isDone", align: "center" },
    { text: "보고서", value: "actions", align: "center" },
];

export const COUNSEL_REQUEST_TYPES = { short: "COUNSEL_REQUEST_SHORT", long: "COUNSEL_REQUEST_LONG" };

export default {
    components: {
        ListHeading,
        CounselsReport,
        CounselsSearch,
        CounselsRequestees,
        CounselsToggleIsdone,
    },
    computed: {
        type() {
            return this.$route.params?.type;
        },
        title() {
            return TITLES[this.type];
        },
        headers() {
            return this.type == "short" ? headers : headers.filter(({ value }) => value !== "isDone");
        },
    },
    data() {
        return {
            ///////////////////////////////////////////////
            // 검색필터
            ///////////////////////////////////////////////
            showsSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            requests: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.search(false);
        },
        async search(routable = true) {
            try {
                if (routable) {
                    this.$router.push({
                        query: Object.assign({}, this.filter, { page: this.page }),
                    });
                }

                var {
                    summary: { totalCount },
                    counselRequests,
                } = await api.console.counsels.gets({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: { ...this.filter, type: COUNSEL_REQUEST_TYPES[this.type] },
                });

                this.pageCount = Math.ceil(totalCount / this.limit);
                this.requests = counselRequests;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        syncItem(item) {
            Object.assignDefined(
                this.requests.find(({ _id }) => _id == item._id),
                item
            );
        },
    },
    watch: {
        $route() {
            this.search(false);

            Object.assign(this.filter, this.$route.query);
            this.page = +this.$route.query.page || 1;
        },
    },
};
</script>
